import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { AmazonS3Location } from 'app/model/dataset/location/amazon-s3.location';
import { FileLocationAdapter } from './file-location.adapter';
import { IModel } from 'shell-models-lib';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonS3Location)
})

export class AmazonS3LocationAdapter extends FileLocationAdapter<AmazonS3Location, Model.DatasetLocation> {
    public _toResource(store: AmazonS3Location): Model.AmazonS3Location {
        const resource: Model.AmazonS3Location = {
            type: this.model().name,
            bucketName: ValueAdapter.toResource(store, AmazonS3Location.CONTAINER) || undefined,
            folderPath: ValueAdapter.toResource(store, AmazonS3Location.FOLDER_PATH) || undefined,
            fileName: ValueAdapter.toResource(store, AmazonS3Location.FILE_NAME) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.AmazonS3Location, owner: Named): AmazonS3Location {
        const model = Owned.create<AmazonS3Location>(this.model(), owner);
        ValueAdapter.toModel(model, AmazonS3Location.CONTAINER, resource.bucketName);
        ValueAdapter.toModel(model, AmazonS3Location.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, AmazonS3Location.FILE_NAME, resource.fileName);
        return model;
    }

    protected model(): IModel {
        return AmazonS3Location.MODEL;
    }
}
